import { utils } from '@tradetrust-tt/tradetrust';
import { ethers } from 'ethers';
import { verificationBuilder, openAttestationVerifiers, w3cVerifiers } from '../verify';

var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
const verifyDocument = /* @__PURE__ */ __name((document, options) => {
  if (typeof options === "string") {
    options = { rpcProviderUrl: options };
  }
  const provider = options?.provider || new ethers.providers.JsonRpcProvider(options?.rpcProviderUrl);
  if (utils.isWrappedV2Document(document) || utils.isWrappedV3Document(document)) {
    const verify = verificationBuilder(openAttestationVerifiers, {
      provider
    });
    return verify(document);
  } else {
    const verify = verificationBuilder(w3cVerifiers, {
      provider,
      documentLoader: options?.documentLoader
    });
    return verify(document);
  }
}, "verifyDocument");

export { verifyDocument };
